import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { CreateEmailCycleRPC } from "./createEmailCycleRPC";

export class CreateEmailCycleRPCClientImpl extends CreateEmailCycleRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: CreateEmailCycleRPC.Request): Promise<LeoRPCResult<CreateEmailCycleRPC.Response, CreateEmailCycleRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/CreateEmailCycle",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      CreateEmailCycleRPC.ResponseDTO,
      CreateEmailCycleRPC.Errors.ErrorsDTO,
      CreateEmailCycleRPC.Response,
      CreateEmailCycleRPC.Errors.Errors
    >(
      response,
      "email-cycle/CreateEmailCycle",
      CreateEmailCycleRPC.Response.fromDTO,
      CreateEmailCycleRPC.Errors.fromDTO
    );
  }
}
